import React, { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button, CircularProgress } from "@mui/material";

const BillingPage = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

    const trialBaseUrl = process.env.REACT_APP_FREE_TRIAL_URL 

    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: `${trialBaseUrl}/trial-start-confirmation`,
      },
    });

    if (result.error) {
      setError(result.error.message);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      {error && <div className="col-danger">{error}</div>}
      <Button type="submit" disabled={!stripe || loading} variant="contained">
        {loading ? <CircularProgress size={24} /> : "Save Card"}
      </Button>
    </form>
  );
};

export default BillingPage;
